<script setup>
import { OnClickOutside } from '@vueuse/components';
import { useI18n } from 'vue-i18n';
import { useDateLocale } from 'dashboard/composables/useTimeAgo';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const props = defineProps({
  options: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  currency: { type: String, default: 'BRL' },
});

const emit = defineEmits(['select', 'close']);

const { t } = useI18n();
const { localeTag } = useDateLocale();

const formatPrice = amount =>
  new Intl.NumberFormat(localeTag.value, { style: 'currency', currency: props.currency }).format(amount);
</script>

<template>
  <OnClickOutside @trigger="$emit('close')">
    <div class="absolute bottom-full left-0 mb-1 z-[200] w-full rounded-lg border border-n-weak bg-n-solid-1 shadow-lg">
      <div class="overflow-y-auto max-h-48 p-1">
        <div v-if="loading" class="flex items-center justify-center py-6">
          <Spinner />
        </div>
        <div v-else-if="options.length === 0" class="px-3 py-4 text-xs text-n-slate-11 text-center">
          {{ t('CONVERSATION.CART.SHIPPING_NO_OPTIONS') }}
        </div>
        <template v-else>
          <button
            v-for="option in options"
            :key="option.service_code"
            class="w-full flex items-center gap-3 px-3 py-2.5 hover:bg-n-alpha-2 text-left border-b border-n-weak last:border-b-0"
            @click="$emit('select', option)"
          >
            <div class="flex-1 min-w-0">
              <p class="text-xs font-medium text-n-slate-12 truncate">{{ option.name }}</p>
              <p class="text-xs text-n-slate-10 truncate">{{ option.carrier }}</p>
            </div>
            <div class="text-right shrink-0">
              <p class="text-xs font-medium text-n-slate-12">{{ formatPrice(option.price) }}</p>
              <p class="text-xs text-n-slate-10">{{ option.delivery_time }} {{ t('CONVERSATION.CART.SHIPPING_DAYS') }}</p>
            </div>
          </button>
        </template>
      </div>
    </div>
  </OnClickOutside>
</template>
